module.exports = {
    path: '/pc/finance/loc/special/xghg25', // String类型 或 Array类型
    pxtorem: false, // Boolean类型 或 Number类型：是否需要px2rem，如果想关闭pxtorem，请把该参数删掉 或者 改为false
    cdncache: 120, // Number类型：cdn缓存时间
    edit: true, // Boolean类型：是否开启可视化
    ssr: false, // Boolean类型：是否开启ssr
    online: true, // Boolean类型：是否上线，仅生产环境有效
    tongji: true, // Boolean类型：是否注入pc统计脚本，注入的碎片地址是：100163
    uiImg: '', // String / Array 类型： UI走查用的图片链接
    allData: {
        transferV3: [
            ['Layout:通栏', 'KVProxy', 'getStructuredFragment', '260239'],
            ['Search:通用搜索', 'KVProxy', 'getStructuredFragment', '20005'],
            ['mainImage:主图', 'KVProxy', 'getStaticFragment', '221776', {}],
            [
                'NewsList:要闻_box1',
                'KVProxy',
                'getRecommendFragment',
                '285897',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'summary', 'children'] },
            ],
            ['NewsListAd:要闻广告_box1', 'KVProxy', 'getStructuredFragment', '260244'],
            ['NewsListSupport:特约合作伙伴_box1', 'KVProxy', 'getStructuredFragment', '260245'],
            ['Title1_1:标题1-1_box1', 'KVProxy', 'getStructuredFragment', '260248'],
            [
                'Swiper1:焦点图_box1',
                'KVProxy',
                'getRecommendFragment',
                '285898',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'summary'] },
            ],
            ['Title1_2:标题1-2_box1', 'KVProxy', 'getStructuredFragment', '260249'],
            [
                'VideoList:视频列表_box1',
                'KVProxy',
                'getRecommendFragment',
                '285899',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'posterUrl', 'videoPlayUrl'] },
            ],
            ['Title2:标题2_box2', 'KVProxy', 'getStructuredFragment', '260247'],
            [
                'Kaimu1:开幕演讲1_box2',
                'KVProxy',
                'getRecommendFragment',
                '285900',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'summary', 'children'] },
            ],
            ['Title3:标题3_box3', 'KVProxy', 'getStructuredFragment', '260250'],
            [
                'Grid1:特别策划_box3',
                'KVProxy',
                'getRecommendFragment',
                '285901',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'summary'] },
            ],
            ['Title4:标题4_box4', 'KVProxy', 'getStructuredFragment', '260251'],
            [
                'LargeVideo:大视频_box4',
                'KVProxy',
                'getRecommendFragment',
                '285905',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'posterUrl', 'videoPlayUrl'] },
            ],
            ['Title5:标题5_box5', 'KVProxy', 'getStructuredFragment', '260252'],
            [
                'exclusiveVideo:独家视频_box5',
                'KVProxy',
                'getRecommendFragment',
                '285907',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'posterUrl', 'videoPlayUrl'] },
            ],
            ['Title6:标题6_box6', 'KVProxy', 'getStructuredFragment', '260253'],
            [
                'GaoQingDaTu:高清大图_box6',
                'KVProxy',
                'getRecommendFragment',
                '285906',
                { filter: ['thumbnails', 'title', 'type', 'url', 'base62Id', 'summary'] },
            ],
            ['Title7:标题7_box7', 'KVProxy', 'getStructuredFragment', '260254'],
            ['Support:赞助列表_box7', 'KVProxy', 'getStructuredFragment', '260240', {}],
            ['NewsULTitle1:相关报道标题1_box7', 'KVProxy', 'getStructuredFragment', '260241', {}],
            ['NewsUL1:相关报道1_box7', 'KVProxy', 'getRecommendFragment', '285902', {}],
            ['NewsULTitle2:相关报道标题2_box7', 'KVProxy', 'getStructuredFragment', '260242', {}],
            ['NewsUL2:相关报道2_box7', 'KVProxy', 'getRecommendFragment', '285903', {}],
            ['NewsULTitle3:相关报道标题3_box7', 'KVProxy', 'getStructuredFragment', '260243', {}],
            ['NewsUL3:相关报道3_box7', 'KVProxy', 'getRecommendFragment', '285904', {}],

            ['Title8:标题8_box8', 'KVProxy', 'getStructuredFragment', '260256'],
            ['TuPianCeHua:图片策划_box8', 'KVProxy', 'getStructuredFragment', '260255', {}],

            ['adHead:广告 head 脚本', 'KVProxy', 'getAd', 'ad_new_chip/s_all-indexs_180823_ad_qpdggtb.inc.html'],
            ['adBody:广告 body 脚本', 'KVProxy', 'getAd', 'ad_new_chip/s_all_indexs_180823_ad_qpdpcggdb.inc.html'],
        ],
    }, // Object类型
    handler: false, // Boolean类型，默认值：false，如果设置为true，需要自己实现allData获取逻辑
};
